import { isAuth, authToken } from "./AuthHelpers";
const init = () => {
  let w = window;
  let status = false;
  w.axios = require("axios");
  // console.log(w.axios)
  if (isAuth) {
    w.axios.defaults.headers.common["Authorization"] = authToken;
    status = true;
  } else {
    status = false;
  }
  return status ? "success" : "failed";
};
export default init;
